<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li class="active">优惠券发放记录</li>
      </ol>
    </div>
    <div class="content-query content-border">
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-button class="btn btn-primary" type="primary" size="small" icon="el-icon-back"
                     @click="$router.push({name:'couponList'})">返回
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <hr/>
    <div class="title">
      <span>优惠券列表</span>
    </div>
    <div class="content-data" v-if="coupons && 0 < coupons.length">
      <el-table highlight-current-row :data="coupons" border ref="multipleTable">
        <el-table-column align="center" type="index"/>
        <el-table-column align="center" label="用户信息" prop="name">
          <template slot-scope="scope">
            <user-info :icon-path="scope.row.iconPath" :nickname="scope.row.nickname"/>
          </template>
        </el-table-column>
        <el-table-column align="center" label="优惠券名称" prop="name"/>
        <el-table-column align="center" label="抵用金额" prop="offsetMoney"/>
        <el-table-column align="center" label="描述">
          <template slot-scope="scope">
            {{ scope.row.couponRemark }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            <span>{{ couponMemberStatusMap[scope.row.status] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="渠道">
          <template slot-scope="scope">
            <span>{{ couponChannelsMap[scope.row.channel] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="类型">
          <template slot-scope="scope">
            <span>{{ couponTypesMap[scope.row.type] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="使用规则">
          <template slot-scope="scope">
            <span>满{{ scope.row.miniPayMoney }}减{{ scope.row.offsetMoney }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="content-data" v-else>
      没有查询到数据
    </div>
    <vue-pager v-bind:datafile="fillData" url="/couponMember/pageCouponMember" v-bind:query="query" ref="pager"
               v-bind:init="true"></vue-pager>
  </div>
</template>
<script>

export default {
  data() {
    return {
      coupons: [],
      query: {},
      couponMemberStatuses: [],
      couponMemberStatusMap: {},

      couponChannels: [],
      couponChannelsMap: {},

      couponTypes: [],
      couponTypesMap: {},

    }
  },
  created() {
    var _this = this;
    if (this.$route.query) {
      this.query.couponId = this.$route.query.couponId
    }
    _this.couponTypes = _this.$common.enum_config('ECouponType');
    _this.couponTypes.forEach((item) => {
      _this.couponTypesMap[item.name] = item.label;
    });
    _this.couponMemberStatuses = _this.$common.enum_config('ECouponMemberStatus');
    _this.couponMemberStatuses.forEach((item) => {
      _this.couponMemberStatusMap[item.name] = item.label;
    });
    _this.couponChannels = _this.$common.enum_config('ECouponChannel');
    _this.couponChannels.forEach((item) => {
      _this.couponChannelsMap[item.name] = item.label;
    });
  },
  methods: {
    openCoupon(_couponId) {
      this.$refs["create-coupon"].openDialog(_couponId)
    },
    fillData(_response) {
      const _this = this;
      _this.coupons = _response.items || [];
    },
    submitQuery(_num) {
      const _this = this;
      _this.coupons = [];
      _this.$refs.pager.gotoPage(_num);
    },
    disableCoupon(_couponId, _status) {
      const _this = this;
      _this.$common.my_ajax({
        url: '/coupon/disableCoupon',
        data: {
          couponId: _couponId,
          status: _status
        },
        success: function (response) {
          _this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1000,
            onClose: function () {
              _this.submitQuery();
            }
          });
        }
      });
    },
    deleteCoupon: function (_tagId) {
      const _this = this;
      _this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$common.my_ajax({
          url: '/tag/deleteTag',
          data: {
            tagId: _tagId
          },
          success: function (response) {
            _this.$message({
              message: '删除成功',
              type: 'success',
              duration: 1000,
              onClose: function () {
                _this.submitQuery();
              }
            });
          }
        });
      }).catch(() => {
        console.log('取消删除');
      });
    }
  }
}
</script>
<style>

</style>
